import { NavigateButton } from '@eastcoal/common/components/Button/NavigateButton'
import { stringifyUrl } from '@eastcoal/common/utils/querystring'

import { APPLY_ANNOUNCEMENT_DETAIL_PAGE_PATH } from '../../../../../../pages/Content/Announcement/Apply/constants/path'

import { HomeAnnouncementDetailButtonProps } from './interface'

export const HomeApplyAnnouncementDetailButton = ({
  record: { announcementId, entranceTicketId }
}: HomeAnnouncementDetailButtonProps) => {
  if (entranceTicketId) {
    return null
  }

  const to = () => {
    return stringifyUrl({
      url: APPLY_ANNOUNCEMENT_DETAIL_PAGE_PATH,
      query: { id: announcementId }
    })
  }

  return (
    <NavigateButton newtab to={to} type='primary'>
      查看预告
    </NavigateButton>
  )
}
